import { LocationDatabaseStore } from 'common/data/location/database/store';
import { DatabaseService } from 'common/service/database/service';
import { LocationDatabaseServiceInterface } from 'common/service/location-database/service.interface';

const service = new LocationDatabaseStore(DatabaseService());

export function LocationDatabaseService(): LocationDatabaseServiceInterface {
  return service;
}
